export default __webpack_public_path__ + "static/HelveticaLT67MediumCondensed-2aec7819f4ddae12d88f498efd86d1d9.woff2";